var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-mapping" },
    [
      _c(
        "b-modal",
        {
          ref: "mapModalRef",
          attrs: {
            title: "Add Mapping",
            "hide-header-close": "",
            centered: ""
          },
          on: { hide: _vm.cancelNewMapping, shown: _vm.focusOnInput }
        },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.KEY")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-input", {
                        ref: "fieldKey",
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("TEMPLATE.KEY")
                        },
                        model: {
                          value: _vm.mapping.key,
                          callback: function($$v) {
                            _vm.$set(_vm.mapping, "key", $$v)
                          },
                          expression: "mapping.key"
                        }
                      }),
                      _vm._v(" "),
                      _vm.mapping.key && !_vm.mapping.isKeyUnique
                        ? _c("div", { staticStyle: { color: "red" } }, [
                            _vm._v("Key must be unique.")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.DATA_TYPE")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-select", {
                        attrs: {
                          plain: true,
                          options: _vm.listTypes,
                          placeholder: "Mapping Type"
                        },
                        on: {
                          input: function($event) {
                            _vm.handleRequired()
                          }
                        },
                        model: {
                          value: _vm.mapping.type,
                          callback: function($$v) {
                            _vm.$set(_vm.mapping, "type", $$v)
                          },
                          expression: "mapping.type"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.mapping.type == "date"
                ? _c(
                    "b-row",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "modal-label", attrs: { cols: "3" } },
                        [_vm._v(_vm._s(_vm.$t("TEMPLATE.DATE_CATEGORY")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("b-form-select", {
                            attrs: {
                              plain: true,
                              options: _vm.dateCategoryList,
                              placeholder: "Select Date Category"
                            },
                            model: {
                              value: _vm.mapping.date_category,
                              callback: function($$v) {
                                _vm.$set(_vm.mapping, "date_category", $$v)
                              },
                              expression: "mapping.date_category"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mapping.type == "date"
                ? _c(
                    "b-row",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "modal-label", attrs: { cols: "3" } },
                        [_vm._v(_vm._s(_vm.$t("TEMPLATE.DATE_FORMAT")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("b-form-select", {
                            attrs: {
                              plain: true,
                              options: _vm.dateFormatList,
                              placeholder: "Select Date Format"
                            },
                            model: {
                              value: _vm.mapping.dateFormat,
                              callback: function($$v) {
                                _vm.$set(_vm.mapping, "dateFormat", $$v)
                              },
                              expression: "mapping.dateFormat"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.MAPPING_CATEGORY")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-select", {
                        attrs: {
                          plain: true,
                          options: _vm.mappingCategories,
                          placeholder: "Mapping Category"
                        },
                        model: {
                          value: _vm.mapping.category,
                          callback: function($$v) {
                            _vm.$set(_vm.mapping, "category", $$v)
                          },
                          expression: "mapping.category"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.ORDER_OF_OCCUR")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-select", {
                        attrs: {
                          plain: true,
                          options: _vm.orderOptions,
                          placeholder: "Mapping Order"
                        },
                        model: {
                          value: _vm.mapping.order,
                          callback: function($$v) {
                            _vm.$set(_vm.mapping, "order", $$v)
                          },
                          expression: "mapping.order"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.canExtract
                ? _c(
                    "b-row",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "modal-label", attrs: { cols: "3" } },
                        [_vm._v(_vm._s(_vm.$t("TEMPLATE.EXT")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("b-form-radio-group", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-radio custom-control-inline"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.mapping.extract,
                                      expression: "mapping.extract"
                                    }
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: { type: "radio", id: "extractYes" },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(_vm.mapping.extract, true)
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.$set(_vm.mapping, "extract", true)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "custom-control-label",
                                    attrs: { for: "extractYes" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-radio custom-control-inline"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.mapping.extract,
                                      expression: "mapping.extract"
                                    }
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: { type: "radio", id: "extractNo" },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(_vm.mapping.extract, false)
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.$set(_vm.mapping, "extract", false)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "custom-control-label",
                                    attrs: { for: "extractNo" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.EXT_BY_WORDS")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-radio-group", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mapping.extract_by_words,
                                  expression: "mapping.extract_by_words"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "extractByWordsYes" },
                              domProps: {
                                value: true,
                                checked: _vm._q(
                                  _vm.mapping.extract_by_words,
                                  true
                                )
                              },
                              on: {
                                change: function($event) {
                                  _vm.$set(
                                    _vm.mapping,
                                    "extract_by_words",
                                    true
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "extractByWordsYes" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mapping.extract_by_words,
                                  expression: "mapping.extract_by_words"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "extractByWordsNo" },
                              domProps: {
                                value: false,
                                checked: _vm._q(
                                  _vm.mapping.extract_by_words,
                                  false
                                )
                              },
                              on: {
                                change: function($event) {
                                  _vm.$set(
                                    _vm.mapping,
                                    "extract_by_words",
                                    false
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "extractByWordsNo" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.REDACT_FIELD")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-radio-group", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mapping.redact_field,
                                  expression: "mapping.redact_field"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "redactFieldYes" },
                              domProps: {
                                value: true,
                                checked: _vm._q(_vm.mapping.redact_field, true)
                              },
                              on: {
                                change: function($event) {
                                  _vm.$set(_vm.mapping, "redact_field", true)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "redactFieldYes" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mapping.redact_field,
                                  expression: "mapping.redact_field"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "redactFieldNo" },
                              domProps: {
                                value: false,
                                checked: _vm._q(_vm.mapping.redact_field, false)
                              },
                              on: {
                                change: function($event) {
                                  _vm.$set(_vm.mapping, "redact_field", false)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "redactFieldNo" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.SHOW_FIELD")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-radio-group", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mapping.show_field,
                                  expression: "mapping.show_field"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "showFieldYes" },
                              domProps: {
                                value: true,
                                checked: _vm._q(_vm.mapping.show_field, true)
                              },
                              on: {
                                change: function($event) {
                                  _vm.$set(_vm.mapping, "show_field", true)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "showFieldYes" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mapping.show_field,
                                  expression: "mapping.show_field"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "showFieldNo" },
                              domProps: {
                                value: false,
                                checked: _vm._q(_vm.mapping.show_field, false)
                              },
                              on: {
                                change: function($event) {
                                  _vm.$set(_vm.mapping, "show_field", false)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "showFieldNo" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.CASE")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-select", {
                        attrs: {
                          plain: true,
                          options: _vm.caseCategories,
                          placeholder: "Case"
                        },
                        model: {
                          value: _vm.mapping.case,
                          callback: function($$v) {
                            _vm.$set(_vm.mapping, "case", $$v)
                          },
                          expression: "mapping.case"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.SENS_DATA")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-radio-group", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mapping.sensitive_data,
                                  expression: "mapping.sensitive_data"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "sensitiveDataYes" },
                              domProps: {
                                value: true,
                                checked: _vm._q(
                                  _vm.mapping.sensitive_data,
                                  true
                                )
                              },
                              on: {
                                change: function($event) {
                                  _vm.$set(_vm.mapping, "sensitive_data", true)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "sensitiveDataYes" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "custom-control custom-radio custom-control-inline"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mapping.sensitive_data,
                                  expression: "mapping.sensitive_data"
                                }
                              ],
                              staticClass: "custom-control-input",
                              attrs: { type: "radio", id: "sensitiveDataNo" },
                              domProps: {
                                value: false,
                                checked: _vm._q(
                                  _vm.mapping.sensitive_data,
                                  false
                                )
                              },
                              on: {
                                change: function($event) {
                                  _vm.$set(_vm.mapping, "sensitive_data", false)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "custom-control-label",
                                attrs: { for: "sensitiveDataNo" }
                              },
                              [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.canShowRequired
                ? _c(
                    "b-row",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "modal-label", attrs: { cols: "3" } },
                        [_vm._v(_vm._s(_vm.$t("TEMPLATE.REQ")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("b-form-radio-group", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-radio custom-control-inline"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.mapping.required,
                                      expression: "mapping.required"
                                    }
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: {
                                    type: "radio",
                                    id: "requiredNewYes"
                                  },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(_vm.mapping.required, true)
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.$set(_vm.mapping, "required", true)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "custom-control-label",
                                    attrs: { for: "requiredNewYes" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("COMMON.YES")))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "custom-control custom-radio custom-control-inline"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.mapping.required,
                                      expression: "mapping.required"
                                    }
                                  ],
                                  staticClass: "custom-control-input",
                                  attrs: { type: "radio", id: "requiredNewNo" },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(_vm.mapping.required, false)
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.$set(_vm.mapping, "required", false)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "custom-control-label",
                                    attrs: { for: "requiredNewNo" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("COMMON.NO")))]
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("TEMPLATE.ALIAS")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("multiselect", {
                        attrs: {
                          "tag-placeholder": "Add this as Alias",
                          placeholder: "Search or add a tag",
                          options: _vm.aliasOptions,
                          multiple: true,
                          taggable: true
                        },
                        on: { tag: _vm.addTag },
                        model: {
                          value: _vm.selectedAliasData,
                          callback: function($$v) {
                            _vm.selectedAliasData = $$v
                          },
                          expression: "selectedAliasData"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "modal-label", attrs: { cols: "3" } },
                    [_vm._v(_vm._s(_vm.$t("COMMON.DESCRIPTION")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-textarea", {
                        attrs: { placeholder: _vm.$t("COMMON.DESCRIPTION") },
                        model: {
                          value: _vm.mapping.description,
                          callback: function($$v) {
                            _vm.$set(_vm.mapping, "description", $$v)
                          },
                          expression: "mapping.description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-100 d-flex justify-content-end",
              attrs: { slot: "modal-footer" },
              slot: "modal-footer"
            },
            [
              _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: {
                    size: "sm",
                    variant: "secondary mr-1",
                    disabled:
                      !_vm.mapping.isKeyUnique ||
                      (_vm.mapping.type == "date" && !_vm.mapping.dateFormat)
                  },
                  on: { click: _vm.createNewMapping }
                },
                [_vm._v(_vm._s(_vm.$t("COMMON.ADD")))]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  staticClass: "float-right",
                  attrs: { size: "sm", variant: "light" },
                  on: { click: _vm.cancelMapping }
                },
                [_vm._v(_vm._s(_vm.$t("COMMON.CANCEL")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "agnetNewMappingModal",
          attrs: {
            title: "New Mapping",
            "hide-header-close": "",
            centered: "",
            "ok-only": "",
            "ok-variant": "secondary"
          },
          on: { ok: _vm.clearDrawing }
        },
        [
          _c("p", [
            _vm._v(
              "You are not permitted to access this. Kindly contact administrator"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fb88cbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb88cbe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/newMapping.vue
// module id = 1115
// module chunks = 2